import React, { Component } from 'react';
import { SelectOption } from 'react-scale/corp/components/UI/Select';
import Select from 'corp/components/UI/Select';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';
import { FindProjectJSON } from '@scale/shared/types/api/corp-api/find';

interface ISelectProjectsInSignupFlowProps {
  value?: SelectOption | SelectOption[];
  onChange?: ((value?: SelectOption) => void) | ((value?: SelectOption[]) => void);
  multi?: boolean;
  includeTestProjects?: boolean;
  className?: string;
}

export default class SelectProjectsInSignupFlow extends Component<ISelectProjectsInSignupFlowProps> {
  async fetchProjects(search: string) {
    if (!search) {
      return [];
    }

    try {
      const query = Object.assign({
        includeTestProjects: this.props.includeTestProjects ?? true,
        search,
      });

      const result = await apiFetch(null, 'corp-api/find/projects', { query });
      const options = result.projects.map((project: FindProjectJSON) => ({
        label: project.name,
        value: project.id,
      }));

      return { options };
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
      return [];
    }
  }

  render() {
    return (
      <Select
        loadOptions={this.fetchProjects.bind(this)}
        ignoreCase={true}
        placeholder="Select a project"
        className={this.props.className}
        {...this.props}
      />
    );
  }
}
